/**
 * Header injected onto outgoing same-origin AJAX requests.
 */
export const MP_REPLAY_ID_HEADER = 'X-MP-REPLAY-Id';

/**
 * sessionStorage key that @fiverr-private/obs writes the Mixpanel mp_replay_id to.
 */
export const MP_REPLAY_ID_STORAGE_KEY = 'mp_replay_id';
